import React, { useRef, useEffect } from 'react';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { BetaContainer, DataContainer } from './styles';
import InscriptionHeader from '../../../../components/Header/InscriptionHeader';
import Animation from '../../../../components/Animation';
import { Typography, Grid, Box } from '@material-ui/core';
import LabelTitle from '../../../../components/Titles/LabelTitle';
import { scrollToTopSelector } from '../../../home/selectors';

const Titles = props => {
	const { t } = useTranslation();
	return (
		<Animation animateIn="fadeInLeft">
			<Box {...props} className="beta__data-titles">
				<LabelTitle content={t('general.beta.label')} />
				<Typography variant="h2" color="textSecondary">
					{t('general.beta.title')}
				</Typography>
			</Box>
		</Animation>
	);
};

const Beta = props => {
	const { t } = useTranslation();
	const ref = useRef(null);

	useEffect(() => {
		if (props.scrollToTop) {
			ref.current.scrollIntoView({
				behavior: 'smooth',
				block: 'start'
			});
		}
	}, [props.scrollToTop]);

	return (
		<BetaContainer ref={ref}>
			<InscriptionHeader />
			<DataContainer>
				<Grid container>
					<Grid item xs={12}>
						<Titles display={{ xs: 'block', sm: 'none' }} />
					</Grid>
				</Grid>

				<Grid container>
					<Grid item xs={12} sm={5} className="beta__data">
						<Titles display={{ xs: 'none', sm: 'block' }} />
						<Animation animateIn="fadeIn" duration={2}>
							<Box mt={3}>
								<Typography variant="body1" className="paragraph-dark" paragraph>
									{t('general.beta.paragraphMain')}
								</Typography>
							</Box>
						</Animation>
					</Grid>
					<Grid item xs={12} sm={7} className="beta__image">
						<div className="inscriptions__image"></div>
					</Grid>
				</Grid>
			</DataContainer>
		</BetaContainer>
	);
};

const mapStateToProps = state => {
	return {
		scrollToTop: scrollToTopSelector(state)
	};
};

const mapDispatchToProps = dispatch => {
	return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(Beta);
